module.exports = __webpack_public_path__ + "static/media/topbar-background-image.740089e9.png";